/**
 * Convert Date to YYYY-MM-DD string for input element
 */
export function dateToInputString(date?: Date | null): string {
	if (!date) return "";
	return date.toISOString().split("T")[0];
}

/**
 * Convert YYYY-MM-DD string to Date
 */
export function inputStringToDate(dateString: string): Date | undefined {
	if (!dateString) return undefined;
	const date = new Date(dateString + "T00:00:00.000Z");
	return isNaN(date.getTime()) ? undefined : date;
}
